import { InternalTab } from '..';
import { TabsList, TabsTrigger } from '../../components/Tabs';

export function InternalTabsList() {
  return (
    <TabsList className="grid w-full grid-cols-4 md:w-[800px]">
      <TabsTrigger value={InternalTab.Utilization}>Utilization</TabsTrigger>
      <TabsTrigger value={InternalTab.Sessions}>Sessions</TabsTrigger>
      <TabsTrigger value={InternalTab.Lifeglovs}>Lifeglovs</TabsTrigger>
      <TabsTrigger value={InternalTab.Surveys}>Surveys</TabsTrigger>
    </TabsList>
  );
}
